    <template>
        <div class="py-4 container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header pb-0">
                            <div class="d-flex align-items-center">
                                <p class="mb-0">Crear crédito</p>
                            </div>
                        </div>
                        <div class="card-body">
                            <form @submit.prevent="submit">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="example-text-input" class="form-control-label"
                                        >DATOS DEL CLIENTE</label
                                        >
                                    </div>
                                    <div class="col-md-6">
                                        <div><label for="example-text-input" class="form-control-label"
                                        >Foto del cliente</label
                                        ></div>
                                        <div>
                                            <img :src="client.photo_url ? client.photo_url : fileUpload" style="max-width:50%;" class="mx-auto"  />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        
                                    </div>
                                    <div class="col-md-6">
                                        <div>
                                        <label for="example-text-input" class="form-control-label"
                                        >Parte Frontal de documento de identidad</label
                                        ></div>
                                        <div>
                                            <img :src="client.document_front_url ? client.document_front_url : fileUpload" style="max-width:50%;" class="mx-auto"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div><label for="example-text-input" class="form-control-label"
                                        >Parte Trasera de documento de identidad</label
                                        ></div>
                                        <div>
                                            <img :src="client.document_back_url ? client.document_back_url : fileUpload" style="max-width:50%;" class="mx-auto"/>
                                        </div>
                                    </div>
                                    
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Documento de identidad</label
                                        >
                                        <argon-input id="code"
                                        type="text" read="true" v-model="client.document" 
                                        />
                                        <small v-if="submitted && v$.client.document.$error" class="text-danger">Documento de identidad es requerido</small>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Tipo de cliente</label
                                        >
                                        <argon-select type="text" read="true" class="form-control" v-model="client.client_type" :choices="type"/>
                                    </div>
                                    <div class="col-md-12">
                                        <label for="example-text-input" class="form-control-label"
                                        >Nombres y Apellidos</label
                                        >
                                        <argon-input id="code"
                                        type="text" read="true" v-model="client.name" 
                                        />
                                        <small v-if="submitted && v$.client.name.$error" class="text-danger">Nombre y apellido es requerido</small>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Sexo</label
                                        >
                                        <argon-select type="text" read="true" class="form-control"  v-model="client.sex" :choices="sex"/>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Fecha de nacimiento</label
                                        >
                                        <VueDatePicker read="true" v-model="client.birth_date" 
                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                        :min-date="minCfgDate" :max-date="maxCfgDate"
                                        :enable-time-picker="false" auto-apply readonly="readonly"/>
                                    </div>
                                    
                                    <div class="col-md-12">
                                        <label for="example-text-input" class="form-control-label"
                                        >Dirección</label
                                        >
                                        <argon-textarea read="true" v-model="client.address"/>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Teléfono</label
                                        >
                                        <argon-input id="code" read="true"
                                        type="text" v-model="client.phone" 
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Correo</label
                                        >
                                        <argon-input id="code" read="true"
                                        type="text" v-model="client.email" 
                                        />
                                    </div>
                                                
                                    <div class="col-md-12">
                                        <label for="example-text-input" class="form-control-label"
                                        >DATOS DEL CRÉDITO</label
                                        >
                                    </div>
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Producto</label
                                        >
                                        <argon-select type="text" class="form-control" v-model="loan.product_id" :choices="products"/>
                                    </div>
                                    <div class="col-md-6"></div>
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Monto Solicitado</label
                                        >
                                        <argon-input-number id="code"
                                        type="number" v-model="loan.amount" :min="min" :max="max"
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Tasa de Interés</label
                                        >
                                        <argon-input id="code"
                                        read="true" 
                                        type="text" v-model="loan.rate" 
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Monto Total</label
                                        >
                                        <argon-input id="code"
                                        read="true" 
                                        type="text" v-model="loan.total_amount" 
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Tasa de Interés Moratorio</label
                                        >
                                        <argon-input id="code"
                                        read="true" 
                                        type="text" v-model="loan.late_interest" 
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Plazo</label
                                        >
                                        <argon-input-number id="code"
                                        type="text" v-model="loan.term" min="3" max="999"
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label">Condición de crédito</label>
                                        <argon-select type="text" class="form-control" v-model="loan.condition_level" :choices="conditions"/>
                                            
                                    </div>
                                    
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Fecha de Inicio</label
                                        >
                                        <VueDatePicker v-model="loan.init_date" 
                                        locale="es"
                                        format="dd/MM/yyyy"
                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                        :min-date="minCfgDate" :max-date="maxCfgDate"
                                        :enable-time-picker="false" auto-apply/>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="example-text-input" class="form-control-label"
                                        >Fecha Final</label
                                        >
                                        <VueDatePicker read="true" v-model="loan.end_date" 
                                        locale="es"
                                        format="dd/MM/yyyy"
                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                        :min-date="minCfgDate" :max-date="maxCfgDate"
                                        :enable-time-picker="false" auto-apply readonly="readonly"/>
                                    </div>
                                    <div class="col-md-12">
                                        <label for="example-text-input" class="form-control-label"
                                        >Comentarios</label
                                        >
                                        <argon-textarea v-model="loan.comments"/>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="table-responsive p-0">
                                            <label for="example-text-input" class="form-control-label"
                                            >PLAN TEORICO DE PAGOS</label
                                            >
                                            <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">No.</th>
                                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Capital</th>
                                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Interés</th>
                                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cargos</th>
                                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha de pago</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in paymentPlan" :key="index">
                                                    <td>{{ item.number }}</td>
                                                    <td>{{ item.date }}</td>
                                                    <td>{{ item.capital}}</td>
                                                    <td>{{ item.interest }}</td>
                                                    <td>{{ item.charges }}</td>
                                                    <td>{{ item.total}}</td>
                                                    <td>
                                                        <span v-if="item.payed === 0" class="text-warning">Pendiente</span>
                                                        <span v-if="item.payed === 1" class="text-success">Pagado</span>
                                                    </td>
                                                    <td>{{ item.payed_date ? item.payed_date : 'N/A' }}</td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                
                                <argon-button
                                type="submit" 
                                class="mt-4"
                                color="success"
                                fullWidth
                                size="lg"
                                @click="insertLoan"
                                >Guardar</argon-button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <script>
    import ArgonInput from "@/components/ArgonInput.vue";
    import ArgonInputNumber from "@/components/ArgonInputNumber.vue";
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css'
    import ArgonSelect from "@/components/ArgonSelect.vue";
    import ArgonTextarea from "@/components/ArgonTextarea.vue";
    import ArgonButton from "@/components/ArgonButton.vue";
    import {useVuelidate} from '@vuelidate/core';
    import {required} from  '@vuelidate/validators';
    import axios from "axios";
    import fileUpload from'@/assets/img/uploadfile.jpg';
    export default {
        name: "company",
        setup:() => ({ v$: useVuelidate() }), 
        data() {
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 15th two months prior
            const minDate = new Date(today)
            minDate.setFullYear(1900)
            minDate.setMonth(minDate.getMonth() - 2)
            minDate.setDate(15)
            // 15th in two months
            const maxDate = new Date(today)
            maxDate.setMonth(maxDate.getMonth())
            maxDate.setDate(maxDate.getDate()+1)
            maxDate.setFullYear(maxDate.getFullYear()+25)
            return {
                fileUpload,
                showMenu: false,
                submitted:false,
                maxCfgDate:maxDate,
                minCfgDate:minDate,
                testClasifications:[],
                testTypes:[],
                client:{
                    document:null,
                    name:null,
                    birth_date:now,
                    sex:1,
                    address:null,
                    email:null,
                    phone:null,
                    client_type:1,
                    education:0,
                    profession:0,
                    company_id:1,
                    qualification:"A",
                    state:1,
                    work_name:null,
                    work_address:null,
                    work_phone:null,
                    photo_url:null,
                    document_front_url:null,
                    document_back_url:null,
                    //created_date:now
                },
                sex:[
                    {value:1,text:'Masculino'},
                    {value:2,text:'Femenino'}
                ],
                type:[
                    {value:1,text:'Persona Natural Nacional'},
                    {value:2,text:'Persona Natural Extranjera'},
                    {value:3,text:'Persona Jurídica Nacional'},
                    {value:4,text:'Persona Jurídica Extranjera'},
                ],
                conditions:[
                    { value: 1, text: 'Diario' },
                    //{ value: 2, text: 'Semanal' },
                    //{ value: 3, text: 'Quincenal' },
                    { value: 4, text: 'Mensual' },
                ],
                products:[
                    {value:1,text:"Consumo personal", default_rate:40, late_rate:10, min:400, max:2700},
                    {value:2,text:"Crédito pyme", default_rate:40, late_rate:10, min:400, max:2700},
                    {value:3,text:"Consolidación de deudas", default_rate:40, late_rate:10, min:400, max:2700},
                    {value:4,text:"Motocicleta", default_rate:40, late_rate:10, min:1000, max:2700},
                ],
                education:[
                    {value:0,text:'Ejemplo'},
                ],
                profession:[
                    {value:0,text:'Ejemplo'},
                ],
                loan:{
                    client_id:this.$route.params.id,
                    amount:0,
                    rate:40,
                    total_amount:0,
                    type:0,
                    term:0,
                    condition_level:4,
                    init_date:today,
                    end_date:today,
                    state:0,
                    company:1,
                    comments:null,
                    balance:0,
                    late_interest:0,
                    product_id:0
                },
                paymentPlan:null,
                min:0,
                max:0
            };
        },
        components: {
            ArgonInput, 
            ArgonInputNumber,
            VueDatePicker,
            ArgonButton, 
            ArgonTextarea, 
            ArgonSelect,
        },
        validations(){
            return{
                client:{
                    document:{required},
                    name:{required},
                    birth_date:{required},
                },
            }
        },
        watch: {
            'loan.term'() {
                this.calculateEndDate();
                this.generarPlanDePagos();
            },
            'loan.condition_level'() {
                this.calculateEndDate();
                this.generarPlanDePagos();
            },
            'loan.init_date'() {
                this.calculateEndDate();
                this.generarPlanDePagos();
            },
            'loan.amount'() {
                this.generarPlanDePagos();
            },
            'loan.rate'() {
                this.generarPlanDePagos();
            },
            'loan.product_id'(newVal) {
                console.log(newVal);
                const selected = this.products.find(p => p.value == newVal);
                if (selected) {
                this.loan.rate = selected.default_rate;
                this.loan.late_interest = selected.late_rate;
                this.min = selected.min;
                this.max = selected.max;
                }
            }
        },
        methods:{
            fetchClientData(config){
                let self=this;
                fetch(this.$store.state.apiURL+'view/clients/'+this.$route.params.id, config)
                .then(response=>response.json())
                .then(result=> {
                    console.log(result); 
                    this.client=result.clients;
                })
                .catch(error => {
                    console.log(error)
                    self.$swal({
                        title: 'Sesión',
                        text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                        type: 'warning',
                        icon:'warning',
                        showCancelButton: false,
                        confirmButtonColor:'#0b9257',
                        showCloseButton: true,
                        showLoaderOnConfirm: false  
                    }).then(function(){
                        localStorage.removeItem('user');
                        localStorage.removeItem('accessToken');
                        self.$router.push('/signin');
                    });    
                });
            },
            uploadPhoto(e){
                console.log(e);
                if(e=='documentFront'){
                    this.$refs.clientFrontFile.click();
                }else if(e=='documentBack'){
                    this.$refs.clientBackFile.click();
                }else{
                    this.$refs.clientPhotoFile.click();
                }
            },
            onFileChange(type, event){
                let self=this;
                const file = event.target.files[0];
                console.log(file)
                let formData=new FormData();
                let fileU;
                let filename='jpg';
                if(file){
                    fileU=URL.createObjectURL(file);
                    console.log(fileU);
                    formData.append('file', file);
                    formData.append('fileName', filename);
                    axios.post(this.$store.state.fileURL, formData,
                        {
                        headers: {
                            "Authorization": "Basic cHJpdmF0ZV9XVXVROG1DQncxV210WHc1empIa3NGQkNZQ1E9Og==",
                            'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'
                        }
                    }).then(function(result){
                        console.log(result);
                        if(type=='front'){
                            self.client.document_front_url=result.data.url;
                        }else if(type=='back'){
                            self.client.document_back_url=result.data.url;
                        }else{
                            self.client.photo_url=result.data.url;
                        }
                    })
                }
            },
            insertLoan(){
                let self= this;
                this.submitted = true;
                this.v$.$touch();
                if(!this.v$.$invalid){
                    const token = localStorage.getItem("accessToken");
                    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
                    console.log(this.loan)
                    const date1 = new Date(this.loan.init_date);
                    const date2 = new Date(this.loan.end_date);
                    this.loan.init_date = date1.toISOString().split('T')[0];
                    this.loan.end_date = date2.toISOString().split('T')[0];
                    axios.post(this.$store.state.apiURL+'add/loans/', this.loan, config)
                    .then((result)=>{
                        console.log(result);
                        let loanId= result.data.loans.id;
                        const requests = this.paymentPlan.map(item => {
                        const payload = {
                            loand_id: loanId,
                            number: item.number,
                            date: new Date(item.date).toISOString().split('T')[0],
                            state: item.state,
                            capital: parseFloat(item.capital),
                            interest: parseFloat(item.interest),
                            total: parseFloat(item.total),
                            payed: 0,
                            payed_date: null
                        };

                        return axios.post(self.$store.state.apiURL+'add/payment_plan', payload,config);
                        });
                        Promise.all(requests)
                        .then((result)=>{
                            console.log(result);
                            self.$swal({
                                title: 'Solicitúd de crédito',
                                text: 'Se generó la solicitúd de crédito de manera satisfactoria',
                                type: 'success',
                                icon:'success',
                                showCancelButton: false,
                                confirmButtonColor:'#0b9257',
                                showCloseButton: true,
                                showLoaderOnConfirm: false  
                            }).then(function(){
                            // self.$router.push('/clients');
                            });
                        })                     
                    });
                }else{
                    self.$swal({
                        title: 'Error en validación',
                        text: 'Encontramos algunos datos incorrectos',
                        type: 'error',
                        icon:'error',
                        showCancelButton: false,
                        confirmButtonColor:'#0b9257',
                        showCloseButton: true,
                        showLoaderOnConfirm: false  
                    });
                } 
                
            },
            calculateEndDate() {
                if (!this.loan.init_date || !this.loan.term || !this.loan.condition_level) return;

                const startDate = new Date(this.loan.init_date);
                
                // Variable de días a agregar
                let daysToAdd = 0;

                switch (Number(this.loan.condition_level)) {
                    case 1: { // Diario
                        const tempDate = new Date(startDate);
                        tempDate.setDate(tempDate.getDate()+Number(this.loan.term));
                        this.loan.end_date = tempDate;
                        return;
                    }
                    case 2: { // Semanal
                        daysToAdd = this.loan.term * 7;
                        break;
                    }
                    case 3: { // Quincenal
                        daysToAdd = this.loan.term * 15;
                        break;
                    }
                    case 4: { // Mensual
                        const tempDate = new Date(startDate);
                        tempDate.setMonth(tempDate.getMonth() + Number(this.loan.term));
                        this.loan.end_date = tempDate;
                        return;
                    }
                    case 5: { // Al vencimiento (mismo día)
                        this.loan.end_date = startDate;
                        return;
                    }
                    default:
                        this.loan.end_date = null; // Si no es un tipo válido
                        return;
                }

                // Si es diario, semanal o quincenal, se agregan días a la fecha
                const resultDate = new Date(startDate);
                resultDate.setDate(resultDate.getDate() + daysToAdd);
                this.loan.end_date = resultDate;
            },
            generarPlanDePagos() {
                this.paymentPlan = []; // Limpiar el plan de pagos antes de recalcular

                const totalLoan = parseFloat(this.loan.amount); // Monto del préstamo
                const annualRate = parseFloat(this.loan.rate) / 100; // Tasa de interés anual
                const paymentCondition = this.loan.condition_level; // Tipo de pago: Diario o Mensual
                const numberOfPayments = this.loan.term; // Número de pagos (plazo)
                const startDate = new Date(this.loan.init_date); // Fecha de inicio

                let intervalDays = 30; // Default para mensual
                let ratePerPeriod = 0;
                let payment = 0;

                // Recálculo de la cuota según la frecuencia seleccionada
                if (paymentCondition == 1) { // Diario
                    ratePerPeriod = parseFloat(this.loan.rate)/100 ;
                    console.log(ratePerPeriod);
                    const interestAmount = parseFloat(totalLoan) * parseFloat(ratePerPeriod);
                    // Nuevo total con interés capitalizado
                    const totalWithInterest = parseFloat(totalLoan) + parseFloat(interestAmount);
                    // Cuota diaria
                    //this.loan.total_amount=parseFloat(totalWithInterest).toFixed(2)
                    payment = parseFloat(totalWithInterest) / parseInt(numberOfPayments);
                    console.log(payment);
                    //this.loan.total_amount = totalWithInterest.toFixed(2);
                } else if (paymentCondition === 4) { // Mensual (Método Francés)
                    ratePerPeriod = annualRate / 12; // Interés mensual
                    // Cálculo para cuota fija (Método Francés)
                    payment = totalLoan * ratePerPeriod / (1 - Math.pow(1 + ratePerPeriod, -numberOfPayments));
                }

                let currentDate = new Date(startDate); // Fecha de inicio
                let remainingBalance = totalLoan;
                console.log(intervalDays)
                for (let i = 0; i < numberOfPayments; i++) {
                    const paymentDate = new Date(currentDate); // Copiar la fecha de inicio

                    if (paymentCondition === 4) {
                        // Para el plan mensual, la primer cuota es el mes siguiente
                        if (i === 0) {
                            paymentDate.setMonth(paymentDate.getMonth() + 1); // Incrementar mes para la primer cuota
                        } else {
                            paymentDate.setMonth(paymentDate.getMonth() + 1); // Incrementar mes para las siguientes cuotas
                        }
                    } else {
                        // Para el pago diario, la primer cuota es el día siguiente
                        if (i === 0) {
                            paymentDate.setDate(paymentDate.getDate() + 1); // Primer pago al día siguiente del inicio
                        } else {
                            paymentDate.setDate(paymentDate.getDate() + 1); // Pagos diarios consecutivos
                        }
                    }

                    currentDate = new Date(paymentDate); // Actualizamos la fecha de pago

                    let interest = 0;
                    let capital = 0;

                    if (paymentCondition === 4) { // Método Francés (Mensual)
                        interest = remainingBalance * ratePerPeriod; // Cálculo de interés mensual
                        capital = payment - interest; // Capital de la cuota
                        remainingBalance -= capital; // Actualizamos el saldo
                    } else { // Cuota Flat (Diario)
                        interest =  0; // Interés diario
                        capital = payment; // Capital de la cuota
                    }

                    // Añadir pago al plan
                    this.paymentPlan.push({
                        date: paymentDate.toISOString().split('T')[0], // Fecha en formato YYYY-MM-DD
                        state: 1, // Estado: Pendiente
                        number:i+1,
                        capital: capital.toFixed(2), // Capital pagado
                        interest: interest.toFixed(2), // Interés pagado
                        charges:0.00,
                        total: (capital + interest).toFixed(2), // Total a pagar (capital + interés)
                        payed: 0, // Pago pendiente
                        payed_date: null // Fecha de pago
                    });

                    this.loan.total_amount=((capital + interest)*numberOfPayments).toFixed(2);
                }
            }
            
        },
        mounted() {
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            this.fetchClientData(config);
            //this.fetchTestTypes(config);
        },
        beforeMount() {

        },
        beforeUnmount() {

        }
    };
    </script>